
import axios from 'axios';
import MatProps from './matProps';
import Loader from '../../components/loader';

const THREE = window.THREE;
const OssHost = "https://infishwaibao.oss-cn-chengdu.aliyuncs.com/scenes/demo/"
function getSceneConfig(name) {
    return axios.get(OssHost + "config.json");
}
function loadGlb ( url ) {
    return new Promise((resolve, reject) => {
        const loader = new THREE.GLTFLoader();
        loader.setCrossOrigin('anonymous');
        loader.load(url, (gltf) => {
            const scene = gltf.scene || gltf.scenes[0];
            resolve(scene);
        }, undefined, reject);
    });
}

function loadEnvMap(renderer) {
    return new Promise((resolve, reject)=>{
      new THREE.TextureLoader().load( OssHost + "images/bg.jpg" , function ( texture ) {
          texture.encoding = THREE.sRGBEncoding;
          let pngBackground = new THREE.WebGLRenderTargetCube( 512, 512 ).fromEquirectangularTexture( renderer, texture );
  
          let pmremGenerator = new THREE.PMREMGenerator( pngBackground.texture );
          pmremGenerator.update( renderer );
  
          let pmremCubeUVPacker = new THREE.PMREMCubeUVPacker( pmremGenerator.cubeLods );
          pmremCubeUVPacker.update( renderer );
  
          let pngCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget;
  
          texture.dispose();
          pmremGenerator.dispose();
          pmremCubeUVPacker.dispose();
          
          resolve( pngCubeRenderTarget.texture )
      });
    })
  }

let scene = null;
async function loadScene(render, app) {

    if( scene ) {
        app.loader = scene;
        return scene;
    }

    let texture = await loadEnvMap(render);

    let output = {
        models:{},
        root: new THREE.Object3D(),
        lights:[],
        mats:[],
        envMap:texture
    }

    let ret = await getSceneConfig();
    if( ret.status != 200) return;  
    let config = ret.data;

    output.lights = config.scene.lights;
    output.mats = config.scene.mats;
    let editableMat = output.mats;

    let models = config.models;
    let n = models.length;
    
    for( let i=0; i<n; i++) {
        let url = models[i].uri;
        let m = await loadGlb(url);
        let name = url.substr( url.lastIndexOf("/") + 1);
        output.models[name] = m;
        output.root.add( m );

        //应用修改的材质
        m.traverse(node=>{
            if( node.isMesh ) {
                let mat = node.material;
                //設置保存的財政
                let n = editableMat.length;
                while(n--) {
                    let cfg = editableMat[n];
                    if( cfg.modelurl == url && cfg.name == mat.name) {
                        let props = new MatProps( mat );
                        props.setJson(cfg);
                        break;
                    }
                }
                mat.envMap = texture;
                mat.needsUpdate = true;
            }
        });

    }
   
    let lights = output.lights;
    if( lights ) {
        lights.forEach( item=>{
            if( item.type == "DirectionalLight") {
              let l = new THREE.DirectionalLight( item.color, item.intensity);
              if( item.p ) {
                  l.position.copy( item.p );
              }
              app.scene.add( l );
            } else if( item.type == 'AmbientLight') {
                let l = new THREE.AmbientLight( item.color, item.intensity);
                app.scene.add( l );
            } else if( item.type == 'PointLight') {
                let l = new THREE.PointLight( item.color, item.intensity);
                l.position.copy( item.p );
                app.scene.add( l );
            }
        });
    }
    scene = output;
    app.loader = scene;
    
    return scene;
}

const Cache = {
    shenque:{
        loading:true,
        imgs:[],
    },
    shangjuxu:{
        loading:true,
        imgs:[],
    },
    sanyinjiao:{
        loading:true,
        imgs:[],
    },
    qimen:{
        loading:true,
        imgs:[],
    },
    taichong:{
        loading:true,
        imgs:[],
    },
    tianshu:{
        loading:true,
        imgs:[],
    },
    dachangyu:{
        loading:true,
        imgs:[],
    }
};
let loading = false;
async function loadImageAnim(){
    if( loading ) return;
    loading = true;
    
    let prefix = "//infishwaibao.oss-cn-chengdu.aliyuncs.com/zyyzhenjiu/anim/";

    let  pre = prefix + "shenque/渲染用_00";
    let imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["shenque"].imgs = imgs;
    Cache["shenque"].loading = false;

    console.log("shenque over");

    pre = prefix + "shangjuxu/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["shangjuxu"].imgs = imgs;
    Cache["shangjuxu"].loading = false;

    console.log("shangjuxu over");

    pre = prefix + "sanyinjiao/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["sanyinjiao"].imgs = imgs;
    Cache["sanyinjiao"].loading = false;

    console.log("sanyinjiao over");

    pre = prefix + "qimen/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["qimen"].imgs = imgs;
    Cache["qimen"].loading = false;

    console.log("qimen over");

    pre = prefix + "taichong/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["taichong"].imgs = imgs;
    Cache["taichong"].loading = false;

    console.log("taichong over");

    pre = prefix + "tianshu/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["tianshu"].imgs = imgs;
    Cache["tianshu"].loading = false;
    console.log("tianshu over");

    pre = prefix + "dachangyu/渲染用_00";
    imgs = await Loader.loaderImages(pre, ".png", 250);
    Cache["dachangyu"].imgs = imgs;
    Cache["dachangyu"].loading = false;
    console.log("dachangyu over");
}

function getImageAnimCach(name)
{
    return Cache[name];
}

export default {
    loadScene,
    loadEnvMap,
    loadImageAnim,
    getImageAnimCach
}